import { render, staticRenderFns } from "./FormBienes.vue?vue&type=template&id=52d6398e&"
import script from "./FormBienes.vue?vue&type=script&lang=js&"
export * from "./FormBienes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports